import { ClickAwayListener, Modal, Box } from "@mui/material";

// import CalendarIcon from '@mui/icons-material/CalendarIcon';

// import { CalendarPicker } from '@mui/x-date-pickers/CalendarPicker';

const Info = ({
  open,
  getSecondaryContent,
  getPrimaryContent,
  handleClose,
}) => {
  return (
    <>
      <Modal
        sx={{
          display: { xs: "block" },
          outline: "none",
          "&:focus": {
            outline: "none",
          },
          zIndex: 1305,
        }}
        outline={"none"}
        open={open}
        onClose={handleClose}
        // hideBackdrop={true}
        slotProps={{
          root: {},
          backdrop: {
            sx: {
              backgroundColor: "rgba(0, 0, 0, 0.2)",
            },
          },
        }}
      >
        {/*<ClickAwayListener onClickAway={handleClose}>*/}
        <Box
          sx={{
            width: "95%",
            "&:focus": {
              outline: "none",
            },
            position: "absolute",
            bottom: "2%",
            left: "50%",
            transform: "translate(-50%, 2%)",
            // backgroundColor: '#fff',
          }}
        >
          <Box
            sx={{
              backgroundColor: "#fff",
              borderRadius: "10px",
              p: 2,
            }}
          >
            {getPrimaryContent()}
          </Box>
          <Box
            sx={{
              mt: 1,
              p: 1,
              backgroundColor: "#fff",
              borderRadius: "10px",
            }}
          >
            {getSecondaryContent()}
          </Box>
        </Box>
        {/*</ClickAwayListener>*/}
      </Modal>
    </>
  );
};

export default Info;
